import { FilledButton } from 'Atoms/buttons/FilledButton';
import { Span } from 'Atoms/text';
import { H1 } from 'Atoms/text/H';
import { MainLayout } from 'layouts/MainLayout';
import styled from 'styled-components/macro';

export const TrialLayout = styled(MainLayout)`
  padding: 50px 0px;

  @media (max-width: ${props => props.theme.breakpoints.l}) {
    padding: 40px 0;
  }
`;

export const Title = styled(H1)`
  margin: 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: 30px 0 0 0;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    padding: 0 10px;
  }
`;

export const ErrorRow = styled.div`
  width: 450px;
  display: flex;
  flex-direction: row;
  position: relative;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    width: 100%;
  }
`;

export const Row = styled.div`
  width: 450px;
  display: flex;
  flex-direction: row;
  position: relative;

  &:not(:first-child) {
    margin-top: 10px;
  }

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    width: 100%;
  }
`;

export const SpecialLink = styled(FilledButton)`
  position: relative;
  box-shadow: none;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 350px;
  height: 40px;
  padding: 10px;

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 300px;
  }

  ${Span} {
    color: ${props => props.theme.colors.filledButton.special.default.textColor};
  }

  &:hover {
    background: ${props => props.theme.colors.filledButton.special.hover.backgroundColor};
    border: 1px solid ${props => props.theme.colors.filledButton.special.hover.borderColor};

    ${Span} {
      color: ${props => props.theme.colors.filledButton.special.hover.textColor};
    }
  }

  &:focus {
    background: ${props => props.theme.colors.filledButton.special.focus.backgroundColor};
    border: 1px solid ${props => props.theme.colors.filledButton.special.focus.borderColor};

    ${Span} {
      color: ${props => props.theme.colors.filledButton.special.focus.textColor};
    }
  }

  transition: background 0.4s, border 0.4s;
`;
